import { Divider, HStack } from '@cdl/heartbeat-react';
import { useSelector } from 'react-redux';
import { getMetricsSelector } from '../metric/selectors/metric.selectors';
import { Metric } from '../metric/types/metric.type';
import { Alert, getAlertLevel } from '../metric/utils/alert.utils';
import { getMetricsMapping } from '../metric/utils/metric.utils';
import * as colors from '../utils/colors';
import { MetricCard } from '../metric/components/MetricCard';
import { displaySelector } from '../layout/selectors/layout.selectors';
import { sexSelector } from '../ecg/selectors/ecg.selectors';

export const Metrics: React.FC = () => {
  const metrics = useSelector(getMetricsSelector);
  const display = useSelector(displaySelector);
  const metricsMapping = getMetricsMapping(display);
  const sex = useSelector(sexSelector);

  const getColor = (metric: Metric) => {
    switch (getAlertLevel(metric, sex)) {
      case Alert.URGENT:
        return colors.metricUrgent;
      case Alert.SIGNIFICANT:
        return colors.metricSignificant;
      default:
        return undefined;
    }
  };

  if (metrics.length === 0) {
    return <div />;
  }

  return (
    <HStack
      bgColor='neutral.0'
      spacing='s'
      p='s'
      borderRadius='4px'
      divider={<Divider orientation='vertical' />}
      shadow={400}
    >
      {metrics.map((metric) => (
        <MetricCard
          key={metric.description}
          label={metricsMapping[metric.description] ?? metric.description}
          value={metric.value}
          metricUnit={metric.unit}
          color={getColor(metric)}
        />
      ))}
    </HStack>
  );
};
